module.exports = __webpack_public_path__ + "static/img/1.6cec7fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20240725/1.jpg
// module id = hkgg
// module chunks = 7